import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import BarChart from './BarChart';

export interface IIRChartDataPoint {
	/**
	 * X Axis Data Point Label
	 */
	xAxisLabel?: string;
	/**
	 * Y Axis Data Point Value
	 */
	yAxisValue?: number;
	/**
	 * Bar data label, shown on bar if the option is enabled
	 */
	dataLabel?: string;
	/**
	 * Used to position data label on bar if necessary, otherwise the position defaults to the center of the bar vertically
	 */
	dataLabelPosition?: number;
}

export interface IIRChartData {
	/**
	 * Individual Chart Heading
	 */
	chartHeading?: string;
	/**
	 * Individual Chart Sub Heading
	 */
	chartSubHeading?: string;
	/**
	 * Label for first dataset, also used for chart dataselect radio button
	 */
	chartFirstDatasetLabel?: string;
	/**
	 * First dataset
	 */
	chartFirstDataset?: IIRChartDataPoint[];
	/**
	 * Label for second dataset, also used for chart dataselect radio button
	 */
	chartSecondaryDatasetLabel?: string;
	/**
	 * Second dataset
	 */
	chartSecondaryDataset?: IIRChartDataPoint[];
	/**
	 * Option to show data labels on chart bars
	 */
	chartShowDataLabels?: boolean;
}

export interface IIRChartsProps extends IBaseElementProps {
	calianIRCharts?: IIRChartData[];
}

/**
 * Calian IR Charts Component
 * @icon chart-bar
 * @block
 */
const IRCharts: React.FC<IIRChartsProps> = ({
	id,
	className,
	classNames = [],
	calianIRCharts,
}) => (
	<div id={id} className={className || cn('calian-ir-charts', ...classNames)}>
		<div className="calian-ir-charts__container container-fluid">
			<div className="row">
				{calianIRCharts &&
					calianIRCharts.length > 0 &&
					calianIRCharts.map((chart, index) => (
						<div
							className="calian-ir-charts__column col-12 col-md-6 col-lg-4"
							key={index}
						>
							<BarChart
								chartDataProps={chart}
								chartIndex={index}
							/>
						</div>
					))}
			</div>
		</div>
	</div>
);

export default IRCharts;
